// Generated by CoffeeScript 1.12.7
var isRelative;

isRelative = function(v) {
  return v[0] === '.';
};

module.exports = function(conf, instance) {
  if (typeof conf === 'string') {
    if (typeof instance === 'function' && isRelative(conf)) {
      return 'factory';
    } else {
      return 'value';
    }
  } else {
    return conf.type;
  }
};
